export const AppRoutes = {
  login: 'login',
  resetPasswordRequest: 'reset-password/request',
  resetPassword: 'reset-password/reset',
  openSession: 'open-session',
  scanPage: 'scan-page',
  closeSession: 'close-session',
  chooseOrderType: 'choose-order-type',
  chooseMealPlan: 'choose-meal-plan',
  order: 'order',
  orderSummary: 'order-summary',
  orderList: 'order-list',
  orderDetail: 'order-detail',
  settings: 'settings',
  adminSettings: 'admin-settings',
  chooseInstance: 'choose-instance',
} as const;

export type AppRoute = (typeof AppRoutes)[keyof typeof AppRoutes];
